// Small platform checks for showing iPhone-only guidance.

/** iPhone / iPod, or an iPad (which reports as a Mac with touch since iPadOS 13). */
export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPhone|iPod|iPad/i.test(ua)) return true;
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
}

/** Running inside the OllaCart iOS app, which shows the site in a frame. */
export function isInOllaCartApp() {
  try {
    return isIOS() && window.self !== window.top;
  } catch (_) {
    return isIOS(); // cross-origin parent — still framed
  }
}

/**
 * onClick for a target="_blank" link to another site. Inside the iOS app's
 * frame a new window can be swallowed (the tap does nothing), so try
 * window.open and, if the app blocks it, send the whole app view there
 * instead. Elsewhere the link opens normally.
 */
export function openOutsideAppFrame(e) {
  if (!isInOllaCartApp()) return;
  const href = e.currentTarget.href;
  if (!href) return;
  e.preventDefault();
  const win = window.open(href, "_blank");
  if (win) {
    try { win.opener = null; } catch (_) {}
    return;
  }
  try {
    window.top.location.href = href;
  } catch (_) {
    window.location.href = href;
  }
}

export const APP_STORE_URL = "https://apps.apple.com/us/app/ollacart/id6476688090";
